exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body span[data-v-e97552f8]{vertical-align:inherit}table.keyvalue[data-v-e97552f8]{margin-bottom:20px}table.keyvalue th[data-v-e97552f8]{font-weight:400}.chart-container .loading-container[data-v-e97552f8]{padding-top:30px}", ""]);

// exports
